const   candidatesActions = {
    IS_PGP:"IS_PGP",
    GET_SEAT_AVAILIBILITY:"GET_SEAT_AVAILIBILITY",
    SET_SEAT_AVAILIBILITY:"SET_SEAT_AVAILIBILITY",
    GET_PCM_PCB_DETAILS:"GET_PCM_PCB_DETAILS",
    SET_PCM_PCB_DETAILS:"SET_PCM_PCB_DETAILS",
    SHOW_INSTRUCTION:"SHOW_INSTRUCTION",
    SET_STATUS:'SET_STATUS',
    SHOW_IMAGE:'SHOW_IMAGE',
    SHOW_COMPRESSED_IMAGE :'SHOW_COMPRESSED_IMAGE',
    SHOW_SIGNATURE:'SHOW_SIGNATURE',
    SHOW_COMPRESSED_SIGNATURE:'SHOW_COMPRESSED_SIGNATURE',
    PROFILE_PERSONAL_DETAILS_CREATION: 'PROFILE_PERSONAL_DETAILS_CREATION',
    GET_PROFILE_PERSONAL_DETAILS : 'GET_PROFILE_PERSONAL_DETAILS',
    SET_PROFILE_PERSONAL_DETAILS : 'SET_PROFILE_PERSONAL_DETAILS',
    PROFILE_ADDRESS_DETAILS_CREATION: 'PROFILE_ADDRESS_DETAILS_CREATION',
    PROFILE_CATEGORY_DETAILS_CREATION: 'PROFILE_CATEGORY_DETAILS_CREATION',
    PROFILE_EDUCATION_DETAILS_CREATION: 'PROFILE_EDUCATION_DETAILS_CREATION',
    PROFILE_EXAM_DETAILS_CREATION: 'PROFILE_EXAM_DETAILS_CREATION',
    PROFILE_CERTIFICATES_DETAILS_CREATION: 'PROFILE_CERTIFICATES_DETAILS_CREATION',
    PROFILE_UPLOADS_DETAILS_CREATION: 'PROFILE_UPLOADS_DETAILS_CREATION',
    PROFILE_UPLOADS_DETAILS_DRAFT_CREATION: 'PROFILE_UPLOADS_DETAILS_DRAFT_CREATION',
    GET_ADDRESS_PERSONAL_DETAILS : 'GET_ADDRESS_PERSONAL_DETAILS',
    SET_ADDRESS_PERSONAL_DETAILS : 'SET_ADDRESS_PERSONAL_DETAILS',
    GET_CATEGORY_PERSONAL_DETAILS : 'GET_CATEGORY_PERSONAL_DETAILS',
    SET_CATEGORY_PERSONAL_DETAILS : 'SET_CATEGORY_PERSONAL_DETAILS',
    GET_EDUCATION_PERSONAL_DETAILS : 'GET_EDUCATION_PERSONAL_DETAILS',
    SET_EDUCATION_PERSONAL_DETAILS : 'SET_EDUCATION_PERSONAL_DETAILS',
    GET_EXAM_PERSONAL_DETAILS : 'GET_EXAM_PERSONAL_DETAILS',
    SET_EXAM_PERSONAL_DETAILS : 'SET_EXAM_PERSONAL_DETAILS',
    GET_CERTIFICATE_PERSONAL_DETAILS : 'GET_CERTIFICATE_PERSONAL_DETAILS',
    SET_CERTIFICATE_PERSONAL_DETAILS : 'SET_CERTIFICATE_PERSONAL_DETAILS',
    PROFILE_PERSONAL_DETAILS_DRAFT_CREATION: 'PROFILE_PERSONAL_DETAILS_DRAFT_CREATION',
    PROFILE_ADDRESS_DETAILS_DRAFT_CREATION: 'PROFILE_ADDRESS_DETAILS_DRAFT_CREATION',
    PROFILE_CATEGORY_DETAILS_DRAFT_CREATION: 'PROFILE_CATEGORY_DETAILS_DRAFT_CREATION',
    PROFILE_EDUCATION_DETAILS_DRAFT_CREATION: 'PROFILE_EDUCATION_DETAILS_DRAFT_CREATION',
    PROFILE_EXAM_DETAILS_DRAFT_CREATION: 'PROFILE_EXAM_DETAILS_DRAFT_CREATION',
    PROFILE_CERTIFICATE_DETAILS_DRAFT_CREATION: 'PROFILE_CERTIFICATE_DETAILS_DRAFT_CREATION',
    GRIEVANCE_QUERY_CREATION : 'GRIEVANCE_QUERY_CREATION',
    GET_QUERY_STATUS_BY_CANDIDATEID : 'GET_QUERY_STATUS_BY_CANDIDATEID',
    SET_QUERY_STATUS_BY_CANDIDATEID : 'SET_QUERY_STATUS_BY_CANDIDATEID',
    GET_OTHER_PERSONAL_DETAILS : 'GET_OTHER_PERSONAL_DETAILS',
    SET_OTHER_PERSONAL_DETAILS : 'SET_OTHER_PERSONAL_DETAILS',
    PROFILE_OTHER_DETAILS_DRAFT_CREATION: 'PROFILE_OTHER_DETAILS_DRAFT_CREATION',
    PROFILE_OTHER_DETAILS_CREATION: 'PROFILE_OTHER_DETAILS_CREATION',
    GET_UPLOAD_PERSONAL_DETAILS : 'GET_UPLOAD_PERSONAL_DETAILS',
    SET_UPLOAD_PERSONAL_DETAILS : 'SET_UPLOAD_PERSONAL_DETAILS',
    GET_COURSE_UPLOAD_PERSONAL_DETAILS : 'GET_COURSE_UPLOAD_PERSONAL_DETAILS',
    SET_COURSE_UPLOAD_PERSONAL_DETAILS : 'SET_COURSE_UPLOAD_PERSONAL_DETAILS',
    SET_PINCODE:'SET_PINCODE',
    GET_PINCODE :'GET_PINCODE',
    SHOW_NO_OPTION_FOR_ENGLISH_MEDIUM:"SHOW_NO_OPTION_FOR_ENGLISH_MEDIUM",
    SHOW_NO_OPTION_FOR_ELCT:"SHOW_NO_OPTION_FOR_ELCT",
    SET_PINCODE_CORRESPONDENCE:'SET_PINCODE_CORRESPONDENCE',
    GET_PINCODE_CORRESPONDENCE :'GET_PINCODE_CORRESPONDENCE',
    GET_FULL_CANDIDATE_DETAILS:'GET_FULL_CANDIDATE_DETAILS',
    GET_FULL_CANDIDATE_DETAIL:'GET_FULL_CANDIDATE_DETAIL',
    SET_FULL_CANDIDATE_DETAILS:'SET_FULL_CANDIDATE_DETAILS',
    COURSE_PERSONAL_DETAILS_CREATION : 'COURSE_PERSONAL_DETAILS_CREATION',
    COURSE_ADDRESS_DETAILS_CREATION : 'COURSE_ADDRESS_DETAILS_CREATION',
    COURSE_ACADEMIC_DETAILS_CREATION : 'COURSE_ACADEMIC_DETAILS_CREATION',
    COURSE_RESERVATION_DETAILS_CREATION : 'COURSE_RESERVATION_DETAILS_CREATION',
    COURSE_EXAM_DETAILS_CREATION : 'COURSE_EXAM_DETAILS_CREATION',
    OTBS_COURSE_EXAM_DETAILS_CREATION:'OTBS_COURSE_EXAM_DETAILS_CREATION',
    GET_COURSE_REGISTRATION_DETAILS : 'GET_COURSE_REGISTRATION_DETAILS',
    SET_COURSE_REGISTRATION_DETAILS : 'SET_COURSE_REGISTRATION_DETAILS',
    GET_COURSE_ADDRESS_DETAILS:'GET_COURSE_ADDRESS_DETAILS',
    SET_COURSE_ADDRESS_DETAILS:'SET_COURSE_ADDRESS_DETAILS',
    OTBS_UPDATE_COURSE_EXAM_DETAILS_CREATION:'OTBS_UPDATE_COURSE_EXAM_DETAILS_CREATION',
    SET_FORM_DATA:"SET_FORM_DATA",
    SET_EDITING_AMOUNT:"SET_EDITING_AMOUNT",
    GET_COURSE_APPLICANTID : 'GET_COURSE_APPLICANTID',
    SET_COURSE_APPLICANTID : 'SET_COURSE_APPLICANTID',
    SET_COURSE_REGISTRATION_DETAILS : 'SET_COURSE_REGISTRATION_DETAILS',
    GET_COURSE_STATUS : 'GET_COURSE_STATUS',
    SET_COURSE_STATUS : 'SET_COURSE_STATUS',
    GET_IS_PAID : 'GET_IS_PAID',
    SET_IS_PAID : 'SET_IS_PAID',
    GET_PAYMENT_RECEIPT_LIST : 'GET_PAYMENT_RECEIPT_LIST',
    SET_PAYMENT_RECEIPT_LIST : 'SET_PAYMENT_RECEIPT_LIST',
    GET_ALL_COURSE_LIST : 'GET_ALL_COURSE_LIST',
    SET_ALL_COURSE_LIST : 'SET_ALL_COURSE_LIST',
    GET_COURSE_TAB : 'GET_COURSE_TAB',
    SET_COURSE_TAB : 'SET_COURSE_TAB',
    SET_MASTER_FIELDS : 'SET_MASTER_FIELDS',
    GET_MASTER_FIELDS : 'GET_MASTER_FIELDS',
    GET_COURSE_ACTIVE_TAB : 'GET_COURSE_ACTIVE_TAB',
    SET_COURSE_ACTIVE_TAB : 'SET_COURSE_ACTIVE_TAB',
    GET_EXAM_STATE : 'GET_EXAM_STATE',
    SET_EXAM_STATE : 'SET_EXAM_STATE',
    GET_EXAM_DISTRICT : 'GET_EXAM_DISTRICT',
    SET_EXAM_DISTRICT : 'SET_EXAM_DISTRICT',
    GET_EXAM_LANGUAGE : 'GET_EXAM_LANGUAGE',
    SET_EXAM_LANGUAGE : 'SET_EXAM_LANGUAGE',
    GET_COURSE_FORM_DETAILS :'GET_COURSE_FORM_DETAILS',
    SET_COURSE_FORM_DETAILS :'SET_COURSE_FORM_DETAILS',
    GET_CURRENT_COURSE :'GET_CURRENT_COURSE',
    SET_CURRENT_COURSE :'SET_CURRENT_COURSE',
    COURSE_PREVIEW_UPDATION : 'COURSE_PREVIEW_UPDATION',
    CREATE_PRINT_LOG : 'CREATE_PRINT_LOG',
    EDIT_COURSE_DETAILS : 'EDIT_COURSE_DETAILS',
    GET_IP_ADDRESS : 'GET_IP_ADDRESS',
    SET_IP_ADDRESS : 'SET_IP_ADDRESS',

    GET_OTBS_VENUE_DETAILS : 'GET_OTBS_VENUE_DETAILS',
    SET_OTBS_VENUE_DETAILS : 'SET_OTBS_VENUE_DETAILS',
    GET_CURRENT_VENUE_DETAILS:'GET_CURRENT_VENUE_DETAILS',
    SET_CURRENT_VENUE_DETAILS:'SET_CURRENT_VENUE_DETAILS',
    GET_VENUE_DETAILS:'GET_VENUE_DETAILS',
    GET_FREE_VENUE_DETAILS:'GET_FREE_VENUE_DETAILS',
    DOWLOAD_BROCHURE:'DOWLOAD_BROCHURE',

    GET_CANDIDATE_COURSE_DETAILS:'GET_CANDIDATE_COURSE_DETAILS',
    SET_CANDIDATE_COURSE_DETAILS:'SET_CANDIDATE_COURSE_DETAILS',
    
    GET_ADMIT_CARD_DOWNLOAD_DETAILS:'GET_ADMIT_CARD_DOWNLOAD_DETAILS',
    GET_ADMIT_CARD_PRINT_DETAILS:'GET_ADMIT_CARD_PRINT_DETAILS',
  

    CREATE_DOWNLOAD_LOG:"CREATE_DOWNLOAD_LOG",
    CREATE_SCORECARD_DOWNLOAD_LOG:"CREATE_SCORECARD_DOWNLOAD_LOG",


    GET_ELIGIBILITY_DETAILS:'GET_ELIGIBILITY_DETAILS',
    SET_ELIGIBILITY_DETAILS:'SET_ELIGIBILITY_DETAILS',


    ADMIT_AND_SCORE_CARD_VIEW_BUTTON_CLICK : 'ADMIT_AND_SCORE_CARD_VIEW_BUTTON_CLICK',
    FREE_REGISTRATION:'FREE_REGISTRATION',


    GET_ADMITCARD_URL:'GET_ADMITCARD_URL',
    SET_ADMITCARD_URL:'SET_ADMITCARD_URL',
    SET_BYPASS_REGISTRATION:"SET_BYPASS_REGISTRATION",
    GET_BYPASS_REGISTRATION:"GET_BYPASS_REGISTRATION",
    GET_AIRPAY_PAYMENT:"GET_AIRPAY_PAYMENT",
    SET_AIRPAY_PAYMNET:"SET_AIRPAY_PAYMNET",
    GET_BILLDESK_PAYMENT:"GET_BILLDESK_PAYMENT",
    SET_BILLDESK_PAYMENT:"SET_BILLDESK_PAYMENT",
    GET_TOTAL_FEE:"GET_TOTAL_FEE",
    SET_TOTAL_FEE:"SET_TOTAL_FEE",
    GET_CANDIDATE_SCRIBE_DETAILS:"GET_CANDIDATE_SCRIBE_DETAILS",
    SET_CANDIDATE_SCRIBE_DETAILS:"SET_CANDIDATE_SCRIBE_DETAILS",

    GET_COURSE_PERSONAL_INFORMATION_DETAILS : 'GET_COURSE_PERSONAL_INFORMATION_DETAILS',
    SET_COURSE_PERSONAL_INFORMATION_DETAILS : 'SET_COURSE_PERSONAL_INFORMATION_DETAILS',

    GET_COURSE_RESERVATION_DETAILS : 'GET_COURSE_RESERVATION_DETAILS',
    SET_COURSE_RESERVATION_DETAILS : 'SET_COURSE_RESERVATION_DETAILS',

    GET_COURSE_ACADEMIC_DETAILS : 'GET_COURSE_ACADEMIC_DETAILS',
    SET_COURSE_ACADEMIC_DETAILS : 'SET_COURSE_ACADEMIC_DETAILS',

    GET_COURSE_EXAMCENTER_DETAILS : 'GET_COURSE_EXAMCENTER_DETAILS',
    SET_COURSE_EXAMCENTER_DETAILS : 'SET_COURSE_EXAMCENTER_DETAILS',

    GET_COURSE_EDITINGFACILITY_DETAILS : 'GET_COURSE_EDITINGFACILITY_DETAILS',
    SET_COURSE_EDITINGFACILITY_DETAILS : 'SET_COURSE_EDITINGFACILITY_DETAILS',

    GET_COURSE_PAYMENTINFORMATION_DETAILS : 'GET_COURSE_PAYMENTINFORMATION_DETAILS',
    SET_COURSE_PAYMENTINFORMATION_DETAILS : 'SET_COURSE_PAYMENTINFORMATION_DETAILS',
    IS_INSTRUCTION_READ:"IS_INSTRUCTION_READ",
    GET_IS_INSTRUCTION_READ:"GET_IS_INSTRUCTION_READ",
    SET_IS_INSTRUCTION_READ:"SET_IS_INSTRUCTION_READ",
    SET_IS_INSTRUCTION_READ_LOADED:"SET_IS_INSTRUCTION_READ_LOADED",
    GET_SCRIBE_DETAILS:"GET_SCRIBE_DETAILS",
    SET_SCRIBE_DETAILS:"SET_SCRIBE_DETAILS",
    UPLOAD_SCRIBE1_PHOTO:"UPLOAD_SCRIBE1_PHOTO",
    UPLOAD_SCRIBE2_PHOTO:"UPLOAD_SCRIBE2_PHOTO",
    GET_SCRIBE1_PHOTO_DETAILS:"GET_SCRIBE1_PHOTO_DETAILS",
    SET_SCRIBE1_PHOTO_DETAILS:"SET_SCRIBE1_PHOTO_DETAILS",
    GET_SCRIBE2_PHOTO_DETAILS:"GET_SCRIBE2_PHOTO_DETAILS",
    SET_SCRIBE2_PHOTO_DETAILS:"SET_SCRIBE2_PHOTO_DETAILS",
    UPLOAD_SCRIBE1_DOCUMENT:"UPLOAD_SCRIBE1_DOCUMENT",
    UPLOAD_SCRIBE2_DOCUMENT:"UPLOAD_SCRIBE2_DOCUMENT",
    GET_SCRIBE1_DOC_DETAILS:"GET_SCRIBE1_DOC_DETAILS",
    SET_SCRIBE1_DOC_DETAILS:"SET_SCRIBE1_DOC_DETAILS",
    SET_SCRIBE2_DOC_DETAILS:"SET_SCRIBE2_DOC_DETAILS",
    GET_SCRIBE2_DOC_DETAILS:"GET_SCRIBE2_DOC_DETAILS",
    GET_CANDIDATE_NAME_FOR_EDITING:"GET_CANDIDATE_NAME_FOR_EDITING",
    SET_CANDIDATE_NAME_FOR_EDITING:"SET_CANDIDATE_NAME_FOR_EDITING",
    GET_CANDIDATE_DOB_FOR_EDITING:"GET_CANDIDATE_DOB_FOR_EDITING",
    SET_CANDIDATE_DOB_FOR_EDITING:"SET_CANDIDATE_DOB_FOR_EDITING",
    GET_CANDIDATE_GENDER_FOR_EDITING:"GET_CANDIDATE_GENDER_FOR_EDITING",
    SET_CANDIDATE_GENDER_FOR_EDITING:"SET_CANDIDATE_GENDER_FOR_EDITING",
    GET_CANDIDATE_GROUP:"GET_CANDIDATE_GROUP",
    SET_CANDIDATE_GROUP:"SET_CANDIDATE_GROUP",
    UPLOAD_SCRIBE1_QUALIFY_DOCUMENT:"UPLOAD_SCRIBE1_QUALIFY_DOCUMENT",
    UPLOAD_SCRIBE2_QUALIFY_DOCUMENT:"UPLOAD_SCRIBE2_QUALIFY_DOCUMENT",
    SET_SCRIBE1_QUALIFY_DOC_DETAILS:"SET_SCRIBE1_QUALIFY_DOC_DETAILS",
    GET_SCRIBE1_QUALIFY_DOC_DETAILS:"GET_SCRIBE1_QUALIFY_DOC_DETAILS",
    SET_SCRIBE2_QUALIFY_DOC_DETAILS:"SET_SCRIBE2_QUALIFY_DOC_DETAILS",
    GET_SCRIBE2_QUALIFY_DOC_DETAILS:"GET_SCRIBE2_QUALIFY_DOC_DETAILS",
    REMOVE_SCRIBE_INFORMATION:"REMOVE_SCRIBE_INFORMATION",
    SET_PCM_NO_OF_ATTEMPTS_FOR_EDITING:"SET_PCM_NO_OF_ATTEMPTS_FOR_EDITING",
    GET_PCM_NO_OF_ATTEMPTS_FOR_EDITING:"GET_PCM_NO_OF_ATTEMPTS_FOR_EDITING",
    SET_CANDIDATE_PCB_NO_OF_ATTEMPTS_FOR_EDITING:"SET_CANDIDATE_PCB_NO_OF_ATTEMPTS_FOR_EDITING",
    GET_CANDIDATE_PCB_NO_OF_ATTEMPTS_FOR_EDITING:"GET_CANDIDATE_PCB_NO_OF_ATTEMPTS_FOR_EDITING",
    SET_NO_OF_ATTEMPTS_EDITING:"SET_NO_OF_ATTEMPTS_EDITING",
    SET_ENG_MEDIUM_EDITING:"SET_ENG_MEDIUM_EDITING",
    GET_NO_OF_ATTEMPTS_EDITING:"GET_NO_OF_ATTEMPTS_EDITING",
    SHOW_PCB_FIRST_ATTEMPT:"SHOW_PCB_FIRST_ATTEMPT",
    SHOW_PCM_FIRST_ATTEMPT:"SHOW_PCM_FIRST_ATTEMPT",
    SHOW_NO_OF_FIRST_ATTEMPT:"SHOW_NO_OF_FIRST_ATTEMPT",
    SET_ELCT:"SET_ELCT"


};

export default candidatesActions;